/* beautiful-react-hooks version: 0.35.0 */
import { useEffect } from 'react';

var useObservable = function useObservable(observable, setter) {
  useEffect(function () {
    var subscription = observable.subscribe(setter);
    return function () {
      return subscription.unsubscribe();
    };
  }, [observable, setter]);
};

export default useObservable;
